import { Injectable } from '@angular/core';

const noop = function() {};
const SERVER_WINDOW: NativeWindow = {
  removeEventListener: noop,
  addEventListener: noop,
  dispatchEvent: noop,
  innerWidth: 0,
  innerHeight: 0,
  scrollY: 0,
  scroll: noop,
  location: {
    href: '',
    reload: noop,
    path: ''
  }
};

export interface NativeWindow {
  [key: string]: any;
}

export abstract class WindowRef {
  get nativeWindow(): NativeWindow {
    throw new Error('Not implemented.');
  }
}

@Injectable()
export class BrowserWindowRef extends WindowRef {
  get nativeWindow(): NativeWindow {
    return window;
  }
}

@Injectable()
export class ServerWindowRef extends WindowRef {
  get nativeWindow(): NativeWindow {
    return SERVER_WINDOW;
  }
}
